<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content-wider custom-list-detail-page">

  <div class="back-container">
    <a [routerLink]="getListsUrl()" (click)="prepareBackNavigation()" class="back-btn">&lt; {{getString('backToLists')}}</a>
  </div>

  <div *ngIf="showLoginRequired" class="custom-list-detail-state">
    <h2>{{getString('myLists')}}</h2>
    <p>{{getString('customListDetailLoginRequired')}}</p>
  </div>

  <div *ngIf="!showLoginRequired && isLoading" class="spinner-container txt-algn-cntr">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!showLoginRequired && !isLoading && hasError" class="custom-list-detail-state">
    <p>{{getString('technicalProblems')}}</p>
    <button type="button" (click)="loadDetail()">{{getString('reload')}}</button>
  </div>

  <div *ngIf="!showLoginRequired && !isLoading && !hasError && detail" class="custom-list-detail">
    <div class="detail-header">
      <div class="detail-title-block">
        <div *ngIf="hasAuthorInfo()" class="author-row">
          <img class="author-image" [src]="getAuthorProfileImage()" alt="" (error)="showImagePlaceholder($event)">
          <span class="author-name">{{getAuthorUsername()}}</span>
        </div>
        <div class="title-row">
          <h2>{{getTitle()}}</h2>
        </div>
        <p *ngIf="getDescription()" class="description">{{getDescription()}}</p>
        <div *ngIf="showDetailMetaRow()" class="detail-meta-row">
          <button type="button" class="detail-like-button" [class.active]="isCustomListLiked()" [disabled]="isLikingCustomList" (click)="toggleCustomListLike($event)">
            <span class="material-icons">{{isCustomListLiked() ? 'favorite' : 'favorite_border'}}</span>
            <span class="detail-like-count">{{getCustomListLikeCount()}}</span>
          </button>
          <span *ngIf="getCategoryTags().length > 0" class="detail-meta-separator"></span>
          <div *ngIf="getCategoryTags().length > 0" class="detail-tag-row">
            <ng-container *ngFor="let tag of getCategoryTags()">
              <a *ngIf="isCategoryTagClickable(tag)" class="detail-tag-chip" [routerLink]="getCategoryTagUrl(tag)" (click)="prepareCategoryTagNavigation(tag)">{{tag.label}}</a>
              <span *ngIf="!isCategoryTagClickable(tag)" class="detail-tag-chip">{{tag.label}}</span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="detail-actions">
        <div class="detail-menu">
          <button type="button" class="menu-trigger" (click)="toggleOptionsMenu($event)" [title]="getString('more')">
            <span class="material-icons">more_vert</span>
          </button>
          <div class="dropdown-content dd-right" [class.dd-open]="isOptionsMenuOpen" [class.dd-close]="!isOptionsMenuOpen">
            <button type="button" class="dd-item" *ngIf="canManageCurrentList()" (click)="deleteList($event)">{{getString('deleteList')}}</button>
            <button type="button" class="dd-item" *ngIf="canManageCurrentList()" (click)="editList($event)">{{getString('editList')}}</button>
            <button type="button" class="dd-item" (click)="duplicateList($event)">{{getString('duplicateList')}}</button>
            <button type="button" class="dd-item" (click)="shareListLink($event)">{{getString('shareLink')}}</button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="allItems.length > 1" class="filters-container-test custom-list-filters-container">
      <div class="small-horizontal-border"></div>

      <div class="normal-filters">
        <div class="filter-test-mobile-sort custom-list-mobile-sort">
          <app-dropdown class="dd-test" [label]="getString('sortBy')" [items]="sortValues"
            [selectedItem]="sortKey" [selectedItemWidth]="'150px'" [right]="true" (onItemSelected)="sortChanged($event)">
          </app-dropdown>
        </div>
        <div class="filter-test custom-list-filter-test">
          <app-dropdown class="dd-test" [label]="getString('wishlist')" [items]="filterValues" [translationKeyOverrides]="filterTranslationKeyOverrides"
            [default]="customListFilterAll" [selectedItem]="filterKey" [selectedItemWidth]="'150px'" [right]="true" (onItemSelected)="filterChanged($event)">
          </app-dropdown>
        </div>
        <div class="filter-test custom-list-filter-test">
          <app-dropdown class="dd-test" [label]="getString('myPurchases')" [items]="purchaseFilterValues"
            [default]="customListFilterAll" [selectedItem]="purchaseFilterKey" [selectedItemWidth]="'150px'" [right]="true" (onItemSelected)="purchaseFilterChanged($event)">
          </app-dropdown>
        </div>
        <div class="filter-test custom-list-filter-test">
          <app-dropdown class="dd-test" [label]="getString('reduced')" [items]="reducedFilterValues"
            [default]="customListFilterAll" [selectedItem]="reducedFilterKey" [selectedItemWidth]="'150px'" [right]="true" (onItemSelected)="reducedFilterChanged($event)">
          </app-dropdown>
        </div>
        <div class="filter-test custom-list-filter-test" *ngIf="getStore() == 'itunes'">
          <app-filter-dropdown #movieRatingsDD class="dd-test" [title]="getString('movieRatings')" [label]="getString('movieRatings')"
            [redText]="hasActiveMovieRatingsFilters()" [selection]="getActiveMovieRatingsFilters()" (onReset)="resetMovieRatingsFilters()" (onOpen)="movieRatingsSliders.init()">
            <app-movie-ratings-sliders #movieRatingsSliders [movieRatingsFilters]="movieRatingsFilters"
              (onApply)="movieRatingsDD.closeDropdown();applyMovieRatingsFilter($event)">
            </app-movie-ratings-sliders>
          </app-filter-dropdown>
        </div>
        <div class="filter-test custom-list-reset-filter-test" *ngIf="hasActiveFiltersOrSort()">
          <span class="reset-filters-label" (click)="resetFiltersAndSort()">{{getString('resetFilters')}} ❌</span>
        </div>
      </div>

      <div class="special-filter custom-list-special-filter">
        <app-dropdown class="sort float-right dd" [selectedItemWidth]="'180px'" [title]="getString('sortBy')" [items]="sortValues"
          [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged($event)">
        </app-dropdown>
      </div>
    </div>

    <div class="content-item-count">{{getItemCount()}} {{getString('items')}}</div>

    <div *ngIf="allItems.length === 0" class="custom-list-detail-state">
      <p>{{getString('noItemsInList')}}</p>
    </div>

    <div *ngIf="allItems.length > 0 && items.length === 0" class="custom-list-detail-state">
      <p>{{getString('noItemsMatchFilter')}}</p>
    </div>

    <div *ngIf="items.length > 0" class="items-container">
      <div class="item-container" *ngFor="let item of items">
        <app-grid-item [item]="item" [priceHint]="'offerslist'" [store]="getStore()" [media]="item.gridItemMedia"
          [disableListActionSafety]="true"
          (onItemClicked)="prepareItemNavigation()"
          (onWishlistClicked)="addToWishlist(item)"
          (onOwnlistClicked)="addToOwnlist(item)"
          (onBlocklistClicked)="addToBlocklist(item)"
          (onRemoveFromWishlistClicked)="removeFromWishlist(item)"
          (onRemoveFromOwnlistClicked)="removeFromOwnlist(item)"
          (onRemoveFromBlocklistClicked)="removeFromBlocklist(item)">
        </app-grid-item>
      </div>
    </div>
  </div>

</div>

<app-modal #deleteListConfirmationModal [title]="getString('deleteList')" [confirmationModal]="true"
[positiveText]="getString('deleteList')"
[negativeText]="getString('cancel')"
(onResult)="onDeleteListConfirmationResult($event)">
  <p>{{getString('deleteListConfirmation')}}</p>
</app-modal>

<app-authentication #authentication></app-authentication>

<app-scroll-top></app-scroll-top>
